module.exports = __webpack_public_path__ + "static/assets/23e468c2c10c1a0c38400b2202bf1073.svg";